import { Nilable } from "@shared/utils";

export interface IItemPreguntaCheckpointDTO {
    id: number;
    text: string;
    checkpoint: boolean;
    item_count: number;
}

export class ItemPreguntaCheckpointDTO {
    public id = 0;
    public texto = "";
    public checkpoint = false;
    public cantidadItem = 0;

    constructor(json: Nilable<Partial<IItemPreguntaCheckpointDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IItemPreguntaCheckpointDTO>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.text != null) {
            this.texto = json.text;
        }
        if (json.checkpoint != null) {
            this.checkpoint = json.checkpoint;
        }
        if (json.item_count != null) {
            this.cantidadItem = json.item_count;
        }
    }
}
